import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as comMod from '../../commonModule';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from "@material-ui/core";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useLocation } from 'react-router-dom';

const useStyle = makeStyles({
  helpButton:{padding: 6, }
})

const HELP_LINKS = {
  "/proseed/upperlimit": "https://rbatos.com/lp/2022/06/14/jougenbasicsetting/",
  "/schedule": "https://rbatos.com/lp/2022/05/09/schedule-monthly/",
  "/schedule/weekly/": "https://rbatos.com/lp/2022/05/30/scheduleweek/",
  '/schedule/users/': 'https://rbatos.com/lp/2022/05/17/schedulebyuser/',
  '/schedule/calender/': 'https://rbatos.com/lp/2022/07/16/holidayssetting/',
  '/reports': 'https://rbatos.com/lp/2022/05/08/reports/',
  '/': 'https://rbatos.com/lp/2022/07/16/helpindexofusers/',
  '/users': 'https://rbatos.com/lp/2022/07/16/helpindexofusers/',
  '/users/belongs': 'https://rbatos.com/lp/2022/07/16/helpindexofusers/',
  '/users/bankinfo': 'https://rbatos.com/lp/2022/07/16/helpindexofusers/',
  '/schedule/weekly/transfer/': 'https://rbatos.com/lp/2022/06/10/pickupanddropoff/',
}

const HelpButton = () => {
  const classes = useStyle();
  const account = useSelector(state => state.account);
  const permission = comMod.parsePermission(account)[0][0];
  
  const ref = useLocation().pathname;
  const help_url = Object.keys(HELP_LINKS).includes(ref) ?HELP_LINKS[ref] :null;
  
  const handleClick = () => {
    if(!help_url) return;
    window.open(help_url, "_blank");
  }
  
  if (permission !== 100) return null;
  const buttonStyle = {color: "#eee", fontSize: 22, marginTop: -2}
  if(help_url){
    return(
      <IconButton type="button" className={classes.helpButton} onClick={handleClick}>
        <HelpOutlineIcon style={buttonStyle}/>
      </IconButton>
    )
  }else{
    return null
  }
}
export default HelpButton